export const excludeFromSpinner = [
  "getImageToken",
  "getVisibleTasks",
  "keepAlive",
  "getEmailsForProcess",
  "getOutboxForProcess",
  "getNextOutboxRun",
  "getDashboardMetrics",
  "getAllCollections",
  "getOrganizationList",
  "getCascadedLinkedOrganizations",
  "getNotificationActivityCount",
  "getMessagesReception",
  "getUserInboxCount",
  "getTaskDelegationTargetSharingGaps",
  "getTaskDelegationTaskModelIdsWithDelegableTasks",
  "getUserOrganizations",
  "getLastLoginDate",
  "getActivityFilterOrganizations",
  "getActivityFilterUsers",
  "getActivityFilterCollections",
  "getActivityFilterCandidates",
  "getActivityFilterProcesses",
  "getCandidateProcessRoleList",
  "getSwitchableOrganizations",
  "getMinimalAnabinDegrees",
  "getMissingDocumentTemplates",
  "getCandidateDocumentTemplates",
  "getCollectionDocumentTemplates",
  "getKpis",
  "getTalentsRestricted",
  "getTalentsPublic",
  "getMarkedTalents",
  "listMarkedTalents",
  "getVisibleCandidateGroupConversations",
  "getVisibleGroupConversations",
  "getVisibleUserConversations",
  "validateProcessModel",
  "getNewUiDashboardOpenTasksMetric",
  "getNewUiDashboardCandidateEventsMetric",
  "getNewUiDashboardCandidateBirthdays",
  "getNewUiDashboardAnkaadiaUpdate",
  "getNewUiDashboardCandidateStates",
  "getNewUiDashboardCandidateStatesAtDate",
  "getNewUiDashboardSharedCollections",
  "getVisibleDashboardWidgets",
  "getAggregatedMilestoneData",
  "getAggregatedMilestoneStates",
  "getMilestoneCandidateStates",
  "getSupportedMilestoneLists",
  "getMilestoneData",
  "getMilestoneTasks",
  "getOverviewOfRequiredDocumentsForProcess",
  "getOverviewOfRequiredDocumentsForCollection",
  "getOverviewOfRequiredDocumentsForCandidate",
  // Dynamic table columns (AB#10349): the cells render their own per-cell skeletons while these resolve,
  // so a full-screen overlay would only hide a table the user can already read and interact with.
  "getAvailableCandidateColumns",
  "getCandidateColumnValues",
  // Expression fields in the process model editor validate while the user types and show their own status tag.
  "validateExpression",
  // The template usage panel (document edit dialog) and popover (e-mail template list) show their own
  // skeleton while these load (AB#22170).
  "getDocumentTemplateProcessUsage",
  "getEmailTemplateProcessUsage",
];
